import isNil from "lodash/fp/isNil";

class Controller {
  constructor(
    $injector,
    Events,
    $stateParams,
    RidesTransforms,
    Sections,
    Lists
  ) {
    "ngInject";
    this.Events = Events;
    this.Lists = Lists;
    this.$stateParams = $stateParams;

    this.sections = Sections.routesSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;

    this.addItemEvent = this.Events.getAddEvent("rides");
    this.filterEvent = this.Events.getFilterEvent("rides");
    this.paginateEvent = this.Events.getPaginateEvent("rides");
    this.sortEvent = this.Events.getSortEvent("rides");
    this.$injector = $injector;
    this.CityHandler = this.$injector.get("CityHandler");
    this.RidesTransforms = RidesTransforms;

    // Get ride category per city
    this.City = $injector.get("City");
    this.dashboardCity = this.CityHandler.get();
    this.getRideCategoriesEvent = this.Events.getUpdateEvent(
      "getRideCategories"
    );
    this.dynamicFiltersEvents = [this.getRideCategoriesEvent];
  }

  $onInit() {
    this.getRideCategory(this.dashboardCity);
  }

  getRideCategory(city) {
    const param = {};
    if (!isNil(city)) {
      param.city = city._id;
    }
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory(param).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.rideCategoryList = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
            param: "category",
          })
        );
      }
      this.Events.emit(this.getRideCategoriesEvent);
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/rides/rides.controller.js